import { useState, useEffect, useRef } from 'react'
import {
  Toolbar,
  SimpleShowLayout,
  ImageInput,
  useDataProvider,
  SimpleForm,
  SelectInput,
  Datagrid,
  TextField,
  TextInput,
  ReferenceInput,
  required,
  FormDataConsumer,
  ArrayField,
  useGetOne,
  RadioButtonGroupInput,
  AutocompleteInput,
  useRecordContext,
  useRefresh,
  email,
  Create,
} from 'react-admin'
import { useNotify } from 'ra-core'
import Grid from '@material-ui/core/Grid'
import {
  Divider,
  Tabs,
  Tab,
  Button,
  Card,
  CardContent,
  CardMedia,
  AppBar,
  Typography,
  Dialog,
  DialogContent,
  Paper,
  Box,
  Switch,
  FormControlLabel,
} from '@material-ui/core'
import { formatLogo, ExtranetContainer, validatePhone } from '../utils'
import SignaturePad from 'react-signature-canvas'
import {
  createTheme,
  ThemeProvider as MuiThemeProvider,
  makeStyles,
} from '@material-ui/core/styles'
import { useLocation, useNavigate } from 'react-router'
import { CustomFileDetailTable } from '../components/file_upload'
import Pill from '../components/pill'
import { useFormContext } from 'react-hook-form'
import ShowMoreText from 'react-show-more-text'
import Api from '../Apis/api.service'
import PreferencesDialog from '../components/PreferencesDialog'
import MyFileField from '../components/common/Inputs/FileField'
import config from '../config'

const useStyles = makeStyles((theme) => ({
  introCard: {
    display: 'flex',
    marginTop: '70px',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      marginTop: '40px',
    },
  },
  introCardContent: {
    flexBasis: '50%',
  },
  introCardMedia: {
    flexBasis: '50%',
    [theme.breakpoints.down('xs')]: {
      height: '100px',
      flexBasis: 'auto',
    },
  },
  wrapper: {
    marginTop: '40px',
    backgroundImage: `url(${config.PUBLIC_URL + '/img/working.svg'})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    minHeight: 'calc(100vh - 100px)',
    backgroundSize: '85%',
  },
  tabBar: {
    marginTop: '-16px',
  },
  Button: {
    backgroundColor: 'black',
    color: 'white',
    cursor: 'pointer',
    fontWeight: '600',
    '&:hover': {
      background: 'white !important',
      color: 'black !important',
      border: '1px solid black',
    },
    '&:disabled': {
      color: '#66666699 !important',
      background: '#e6e5e5a8 !important',
      borderColor: '#e4e6ef !important',
    },
  },
  contenuParagraph: {
    fontSize: '1em',
    fontFamily: 'Arial, sans-serif',
    fontWeight: '500',
    lineHeight: '1.57',
    color: 'black',
  },
  mainShoMore: {
    display: 'flex',
    alignItems: 'center',
  },
  spanMore: {
    marginLeft: '5px',
    color: 'black',
  },
  anchorClass: {
    textDecoration: 'underline',
    color: 'blue',
    cursor: 'pointer',
  },
  resolutionDisplayDiv: {
    display: 'flex',
    minWidth: '169px',
    alignItems: 'center',
    borderRight: '2px solid #e0e0e0',
    paddingRight: '10px',
    justifyContent: 'space-around',
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      padding: '.7em 0',
      borderRight: 'none',
      borderBottom: '2px dotted #cecece',
      marginBottom: '1em',
      flexDirection: 'row',
    },
  },
  resolutionDisplayFlex: {
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  percent: {
    alignItems: 'center',
    borderRadius: '5px',
    justifyContent: 'center',
    height: '10px',
    display: 'flex',
    color: 'white',
    marginTop: '5px',
    fontSize: '12px',
  },
  badges: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'center',
    rowGap: '10px',
  },
}))

var sigPad = {}

const Title1 = (props) => {
  const { basePath, variant, ...rest } = props
  return (
    <div>
      <Typography variant="h6" {...rest}>
        Enregistrez-vous
      </Typography>
      <br />
    </div>
  )
}

const Title2 = (props) => {
  const { basePath, variant, ...rest } = props
  return (
    <div>
      <Typography variant="h6" {...rest}>
        Votez
      </Typography>
      <br />
    </div>
  )
}

const Title3 = (props) => {
  const { basePath, variant, ...rest } = props
  return (
    <Typography
      variant="h6"
      {...rest}
      style={{ textDecoration: 'underline', margin: '1em 0' }}
    >
      Résolution
    </Typography>
  )
}

const Title4 = (props) => {
  const { basePath, variant, ...rest } = props
  return (
    <div>
      <Typography variant="h6" {...rest}>
        Résolutions et résultats
      </Typography>
      <br />
    </div>
  )
}

const AGNotAvailable = () => (
  <>
    <Typography>Cette AG n'est pas encore, ou plus accessible.</Typography>
    <HelpSection />
  </>
)

const CreateVoteToolbar = (props) => {
  const handleClick = (event) => {
    props.handleSubmit(props.redirect)
  }
  const { vote } = props
  const classes = useStyles()
  return (
    <div style={{ padding: '1rem 0' }}>
      <Button
        fullWidth
        size="large"
        variant="contained"
        className={classes.Button}
        disabled={vote ? true : false}
        disableElevation
        onClick={handleClick}
      >
        Valider le vote
      </Button>
    </div>
  )
}

export const RegisterToolbar = (props) => {
  const { handleSubmit } = useFormContext()
  const onSubmit = () => {
    props.handleSubmit(props.redirect)
  }
  return (
    <Toolbar fullWidth>
      <Button
        fullWidth
        size="large"
        variant="contained"
        color="primary"
        disableElevation
        onClick={handleSubmit(onSubmit)}
        type="submit"
      >
        Valider l'enregistrement
      </Button>
    </Toolbar>
  )
}

//NOTE: Passing a custom save props to SimpleForm works usually, but NOT when it is child of a Create component, I have no idea why.
//I had to create this wrapper to make the save function override work...
const SimpleFormWrapper = (props) => {
  const { save, submit, ...rest } = props
  return <SimpleForm save={submit} variant="outlined" {...rest} />
}

const optionRenderer = (choice) => (choice ? `${choice.name}` : null)

const Sig = (props) => {
  if (document.getElementById('widthmarker') === null) {
    return null
  }
  const width = document.getElementById('widthmarker').clientWidth
  return (
    <SignaturePad
      canvasProps={{ width: width, height: 200, className: 'sigCanvas' }}
      backgroundColor="white"
      ref={props.init}
      onEnd={props.sigChange}
    />
  )
}

const Signature = (props) => {
  const init = (ref) => {
    sigPad = ref
    if (window.signature_path !== undefined && sigPad !== null) {
      sigPad.fromDataURL(window.signature_path)
    }
  }

  const clear = () => {
    sigPad.clear()
    window.signature_path = undefined
  }
  const sigChange = () => {
    window.signature_path = sigPad.getTrimmedCanvas().toDataURL('image/png')
  }

  //NOTE for signature pad: if we don't specify width and height explicitly with canvasProps,
  //mouse and pencil are misaligned
  //NOTE 2: SignaturePad outer div takes whole width but canvas has fixed width.
  // PB1: on desktop, on the right the signaturePad does not work (where you're outside the canvas)
  // PB2: on mobile, the canvas overflows from the form
  // Ideally, canvas width would be dynamic, to match outer div width
  // => we did that with <Sig /> component
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="stretch"
      justify="center"
      key={props.key}
    >
      <Grid item xs={12}>
        <Typography style={{ color: '#2b2b2b' }}>
          <br />
          Signature:
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <div
          style={{ border: '1px solid #2b2b2b', borderRadius: '5px' }}
          id="widthmarker"
        >
          <Sig init={init} sigChange={sigChange} />
        </div>
        <br />
      </Grid>
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justify="center"
      >
        <Grid item xs={12}>
          <Button color="secondary" onClick={clear}>
            Effacer la signature
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}

const CoOwnerInput = ({ coowners, onChange }) => {
  const { setValue } = useFormContext()

  return (
    <AutocompleteInput
      fullWidth
      optionText={optionRenderer}
      onChange={(value) => {
        onChange?.(value)

        const selectedCoowner = coowners.find((coowner) => coowner.id === value)
        if (selectedCoowner) {
          setValue('email', selectedCoowner.email)
          return
        }
        setValue('email', '')
      }}
      validate={required()}
      matchSuggestion={() => true}
      helperText="Ou sélectionnez le copropriétaire que vous représentez"
    />
  )
}
//NOTE: UGLY HACK: we use window to store formData and use it as initial values, so that
//it is not wiped out when there is a refresh.
//Not possible to use state variable because it seems on refresh the component is destroyed (since state variables are reinitialized)
export const Register = (props) => {
  const dataProvider = useDataProvider()
  const location = useLocation()
  const notify = useNotify()
  const [showDialog, setShowDialog] = useState(false)
  const [showDialogPref, setShowDialogPref] = useState(false)
  const [data, setData] = useState({})
  const [coowners, setCoowners] = useState([])
  const [coownerId, setCoownerId] = useState(null)
  const toggleDialog = () => setShowDialog(!showDialog)
  const [formrecord, setFormrecord] = useState(false)
  const [key, setKey] = useState(new Date().getTime())

  useEffect(() => {
    dataProvider
      .getList('ext_coproprietaires', {
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'name', order: 'ASC' },
      })
      .then(({ data }) => {
        setCoowners(data.map((coowner) => ({ ...coowner, email: '' })))
      })
      .catch((error) => {
        console.error(error)
      })
  }, [])

  useEffect(() => {
    setKey(() => {
      return new Date().getTime()
    })
  }, [location])
  //we have to use a custom save function, to have a callback for refresh
  const createReg = (redirect) => {
    if (window?.signature_path === undefined) {
      alert('Veuillez fournir votre signature sur le pad.')
      return
    }
    let dataToSend = { ...window?.formData2 }
    dataToSend.signature_path = window?.signature_path
    setFormrecord(dataToSend)
    setShowDialog(true)

    return
  }
  const checkCourier = async (id) => {
    const res = await Api.extContactpref.get(id)
    if (
      (res.status == 200 && res.data.paper == null) ||
      res.data.paper == true
    ) {
      setShowDialogPref(true)
      setData(res.data)
    } else {
      props.toVote()
    }
  }
  const createReg2Yes = () => {
    dataProvider
      .create('ext_agregistrations', {
        data: { consent: 'yes', ...formrecord },
      })
      .then((response) => {
        props.refresh()
        alert('Vous êtes enregistré.')
        setShowDialog(false)
        checkCourier(response.data.coproprietaire_id)
      })
      .catch((error) => {
        alert(error.message)
        notify(error.message, 'warning')
      })
  }

  const validateFileExtension = (value) => {
    if (value && value.length === 2) {
      const fileExtension = value[1].title.split('.').pop()
      if (fileExtension !== 'pdf' && fileExtension !== 'jpg') {
        notify(
          'Le fichier doit être au format .pdf ou .jpg. Format actuel : .' +
            fileExtension,
          { type: 'error' }
        )
        return (
          'Le fichier doit être au format .pdf ou .jpg. Format actuel : .' +
          fileExtension
        )
      }
    }
  }

  const createReg2No = () => {
    dataProvider
      .create('ext_agregistrations', { data: { consent: 'no', ...formrecord } })
      .then((response) => {
        props.refresh()
        alert('Vous êtes enregistré.')
        setShowDialog(false)
        checkCourier(response.data.coproprietaire_id)
      })
      .catch((error) => {
        alert(error.message)
        notify(error.message, 'warning')
      })
  }
  const classes = useStyles()

  //ImageInput label cannot be in placeholder location so we put all info in placeholder.
  //We remove required props in order not to have a * near empty label, and we validate this upload in the back instead
  return (
    <div>
      <Dialog
        open={showDialog}
        onClose={toggleDialog}
        fullWidth={true}
        maxWidth={'sm'}
      >
        <DialogContent>
          <Typography
            style={{
              marginTop: '20px',
              fontSize: '20px',
              color: '#133a5f',
              lineHeight: '31.2px',
              fontWeight: '700',
              fontFamily: 'Helvetica',
            }}
          >
            Vous êtes sur le point de valider votre enregistrement à l’assemblée
            générale.
          </Typography>
          {/* <Button
            color="primary"
            variant="contained"
            onClick={createReg2Yes}
            disableElevation
          >
            J’accepte l’utilisation des données limitées aux activités décrites
            et l’utilisation du format dématérialisé
          </Button>
          <Button variant="contained" onClick={createReg2No} disableElevation>
            J’accepte l’utilisation des données limitées aux activités décrites
            et l’utilisation du format papier uniquement
          </Button> */}
          <Typography style={{ margin: '20px 0' }}>
            <b>
              Vous allez recevoir un code de confirmation personnel par SMS,
              vous en aurez besoin. Ce code vous sera demandé pour voter dans le
              cadre de l’assemblée générale.
            </b>
          </Typography>
          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '20px',
            }}
          >
            <Button
              className={classes.Button}
              variant="contained"
              onClick={createReg2Yes}
              disableElevation
            >
              Valider l'enregistrement
            </Button>
          </Box>
          <Typography style={{ fontSize: '12.5px' }}>
            <span style={{ display: 'block' }}>
              Les informations recueillies sur ce formulaire sont enregistrées
              dans un fichier informatisé par Manda (Ex-Hello Syndic) dans le
              cadre du contrat qui lie les copropriétaires à Manda (Ex-Hello
              Syndic). Les données collectées seront communiquées aux seuls
              destinataires suivants : Manda (Ex-Hello Syndic), ou toute société
              mandatée dans le cadre d’une intervention dans le cadre de
              l’activité de Manda (Ex-Hello Syndic). Vous pouvez retirer à tout
              moment votre consentement au traitement de vos données. Vous
              pouvez également vous opposer au traitement de vos données. Vous
              pouvez également exercer votre droit à la portabilité de vos
              données. Consultez le site cnil.fr pour plus d’informations sur
              vos droits. Pour exercer ces droits ou pour toute question sur le
              traitement de vos données dans ce dispositif, vous pouvez
              contacter copro@manda.fr ou via Manda (Ex-Hello Syndic), 30
              Terrasse Bellini - 92800 Puteaux
            </span>
            <span>
              Vous pouvez accéder aux données vous concernant, les rectifier,
              demander leur effacement ou exercer votre droit à la limitation du
              traitement de vos données.
            </span>
          </Typography>
        </DialogContent>
      </Dialog>
      <SimpleForm
        toolbar={<RegisterToolbar handleSubmit={createReg} />}
        defaultValues={{
          ag_id: props.ag.id,
          ...window.formData2,
          representant: null,
        }}
        redirect={false}
        resource="ext_agregistrations"
        basePath="/"
        variant="outlined"
      >
        <Title1 />
        <ReferenceInput
          label="Copropriétaire"
          source="coproprietaire_id"
          reference="ext_coproprietaires"
          validate={required()}
          sort={{ field: 'co.libelle', order: 'ASC' }}
        >
          <CoOwnerInput
            coowners={coowners}
            onChange={(value) => {
              setCoownerId(value)
            }}
          />
        </ReferenceInput>
        <TextInput
          fullWidth
          label="N° de tel. portable"
          source="phone"
          validate={[required(), validatePhone]}
        />
        <TextInput
          fullWidth
          label="Email"
          source="email"
          validate={[required(), email()]}
        />
        <AutocompleteInput
          onCreate={(filter) => {
            const newMandatary = {
              id: coowners.length + 1,
              name: filter,
            }
            coowners.push(newMandatary)
            return newMandatary
          }}
          source="representant"
          choices={coowners
            .filter((choiceCoowner) => choiceCoowner.id !== coownerId)
            .toSorted((a, b) => (a.name < b.name ? -1 : 1))}
          optionText="name"
          optionValue="name"
          label="Nom du mandataire"
          helperText="Si vous représentez quelqu'un"
          fullWidth
        />
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            window.formData2 = formData
            return null
          }}
        </FormDataConsumer>
        <Signature key={key} />
        <HelpSection />
        <PreferencesDialog
          data={data}
          id={window?.formData2?.coproprietaire_id}
          poidsPapier={props?.ag?.poidsPapier}
          co2={props?.ag?.co2}
          montant={props?.ag?.montant}
          showDialog={showDialogPref}
          toggleDialog={() => setShowDialogPref(!showDialogPref)}
        />
      </SimpleForm>
    </div>
  )
}

//NOTE: we don't use a Create function here, so that the register form is out of refresh() impact
//NOTE: when we change tab this component is recreated so state does not persist (for voted state variable)
const Vote = (props) => {
  const { voted, setVoted } = props

  const dataProvider = useDataProvider()
  const notify = useNotify()
  const [inputVote, setInputVote] = useState(null)
  const record = props.ag
  const refresh = useRefresh()
  if (!record) return null
  const open_resolution_id = record.open_resolution_id
  //check if input
  const [resolution, setResolution] = useState(open_resolution_id)
  const majorite = record.open_resolution_majorite

  const Reset = () => {
    const { setValue } = useFormContext()
    useEffect(() => {
      if (!voted) {
        setValue('vote', null)
      }
    }, [voted])
    return null
  }

  const createVote = () => {
    setVoted('')
    if (open_resolution_id !== resolution) {
      setResolution(open_resolution_id)
    }
    dataProvider
      .create('ext_votes', { data: { ...window.formData2, ...record } })
      .then((response) => {
        refresh()
        setVoted('1')
        setResolution(record.open_resolution_id)
      })
      .catch((error) => {
        notify(error.message, 'warning')
      })
  }
  const checkVoted = (token) => {
    if (token) {
      dataProvider
        .getOne(`ext_votes/check_vote/${token}`, {
          id: record.open_resolution_id,
        })
        .then(({ data }) => {
          if (!data.ok) {
            setVoted(data.message)
          } else {
            setVoted('')
          }
        })
        .catch((error) => {
          console.log('error', error)
        })
    }
  }

  if (majorite === 'sans vote')
    return (
      <SimpleFormWrapper
        toolbar={null}
        defaultValues={{ ag_id: props.ag.id, ...window.formData2 }}
        redirect={false}
        submit={createVote}
        resource="ext_votes"
        basePath="/"
      >
        <Title3 />
        <ResolutionDisplay agRecord={props.ag} />
        <HelpSection />
      </SimpleFormWrapper>
    )

  return (
    <SimpleForm
      toolbar={false}
      defaultValues={{ ag_id: props.ag.id, ...window.formData2 }}
      redirect={false}
      resource="ext_votes"
      basePath="/"
    >
      <Title2 />
      <Reset />
      <TextInput
        fullWidth
        label="Code de vote"
        source="token"
        value={inputVote}
        onBlur={(e) => {
          if (!e.target.value) {
            setVoted('')
          } else {
            checkVoted(e.target.value)
          }
        }}
        validate={required()}
      />
      <Typography fullWidth variant="subtitle2">
        L'AG a démarré. Le vote est ouvert pour la résolution en cours.
      </Typography>
      <SelectInput
        fullWidth
        label="Vote"
        source="vote"
        validate={required()}
        choices={[
          { id: 'Pour', name: 'Pour' },
          { id: 'Contre', name: 'Contre' },
          { id: 'Abstention', name: 'Abstention' },
        ]}
      />
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          window.formData2 = formData
          return null
        }}
      </FormDataConsumer>
      {voted && (
        <Pill
          id="danger"
          value={voted ? 'Vous avez voté' : ''}
          status="primary"
        />
      )}
      <br />
      <Title3 />
      <ResolutionDisplay
        agRecord={props.ag}
        vote={voted}
        handleSubmit={createVote}
      />
      <HelpSection />
    </SimpleForm>
  )
}

export const PreVote = (props) => {
  const dataProvider = useDataProvider()
  const notify = useNotify()
  const [voted, setVoted] = useState(false)
  const refresh = useRefresh()
  const resource = props.vpc === true ? 'prevotes' : 'ext_prevotes'
  const classes = useStyles()
  const createVote = () => {
    dataProvider
      .create(resource, { data: { ...window.formData2, ...props.ag } })
      .then((response) => {
        refresh()
        notify('Vous avez voté.')
        setVoted(true)
      })
      .catch((error) => {
        notify(error.message, 'warning')
      })
  }

  return (
    <SimpleFormWrapper
      toolbar={<CreateVoteToolbar handleSubmit={createVote} />}
      defaultValues={{ ag_id: props.ag.id, ...window.formData2 }}
      redirect={false}
      resource={resource}
      basePath="/"
    >
      <Title2 />
      {props.vpc === true ? (
        <SelectInput
          fullWidth
          label="Copropriétaire"
          source="coproprietaire"
          choices={props.coproprietaires}
          validate={required()}
          onChange={(e) => {
            props.setCurrentCoowner(e.target.value)
          }}
        />
      ) : (
        <TextInput
          fullWidth
          label="Code de vote"
          source="token"
          validate={required()}
        />
      )}
      <Typography fullWidth variant="subtitle2">
        L'AG n'a pas encore démarré. Vous pouvez voter en avance pour chaque
        résolution.
      </Typography>
      {props.resolutions.map((r) => {
        return (
          <>
            <RadioButtonGroupInput
              fullWidth
              source={'param_res_' + r.id}
              label={r.name}
              choices={[
                { id: 'Pour', name: 'Pour' },
                { id: 'Contre', name: 'Contre' },
                { id: 'Abstention', name: 'Abst.' },
              ]}
              key={r.id}
              helperText={false}
            />
            <ShowMoreText
              lines={3}
              more="Plus"
              less="Moins"
              expanded={false}
              anchorClass={classes.anchorClass}
              className={classes.contenuParagraph}
            >
              <div dangerouslySetInnerHTML={{ __html: r.contenu }}></div>
            </ShowMoreText>
          </>
        )
      })}
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          window.formData2 = formData
          return null
        }}
      </FormDataConsumer>
      {voted ? (
        <Pill id="success" value={<b>Vous avez voté</b>} status="primary" />
      ) : (
        <div />
      )}
      <HelpSection />
    </SimpleFormWrapper>
  )
}
export const HelpSection = () => (
  <>
    <br />
    <Typography
      style={{ width: '100%', textAlign: 'center', fontSize: '14px' }}
    >
      Si vous avez besoin d’aide, envoyez "AG Help" au{' '}
      <a href="tel:06 44 64 11 12"> 06 44 64 11 12</a>
    </Typography>
  </>
)

export const RegisterWrapper = (props) => {
  const { basePath, ...rest } = props
  const ag = props.ag

  if (ag === undefined) {
    return null
  }
  if (ag.code === 1) return <AGNotAvailable />
  if (ag.open_resolution_id !== null) {
    return (
      <Register ag={props.ag} toVote={props.toVote} refresh={props.refresh} />
    )
  } else {
    return (
      <Register
        ag={props.ag}
        preregister={true}
        toVote={props.toVote}
        refresh={props.refresh}
      />
    )
  }
}
export const VoteWrapper = (props) => {
  const { basePath, setVoted, voted, inputVoteRef, ...rest } = props
  const ag = props.ag
  const [currentCoownerId, setCurrentCoownerId] = useState(null)
  const [resolutions, setResolutions] = useState([])

  useEffect(() => {
    if (currentCoownerId) {
      const coownerFound = ag.coproprietaires.find(
        (coowner) => coowner.id === currentCoownerId
      )

      if (!coownerFound) return
      setResolutions(
        coownerFound.resolutions_ids.map((id, idx) => {
          return {
            id: id,
            name: coownerFound.resolutions_libelles[idx],
            contenu: ag.resolutions_contenus
              ? ag.resolutions_contenus[idx]
              : '',
          }
        })
      )
    } else {
      setResolutions(
        ag.resolutions_ids.map((id, idx) => {
          return {
            id: id,
            name: ag.resolutions_libelles[idx],
            contenu: ag.resolutions_contenus
              ? ag.resolutions_contenus[idx]
              : '',
          }
        })
      )
    }
  }, [currentCoownerId])

  if (ag === undefined) return null
  if (ag.code === 1) return <AGNotAvailable />

  if (ag.open_resolution_id !== null && props.vpc !== true) {
    return (
      <Vote
        {...props}
        setVoted={setVoted}
        voted={voted}
        inputVoteRef={inputVoteRef}
        {...rest}
      />
    )
  }
  if (props.vpc === true) {
    return (
      <PreVote
        ag={ag}
        resolutions={resolutions}
        refresh={props.refresh}
        vpc={props.vpc}
        coproprietaires={props.coproprietaires}
        setCurrentCoowner={setCurrentCoownerId}
      />
    )
  }

  return (
    <PreVote
      ag={ag}
      resolutions={resolutions}
      setCurrentCoowner={setCurrentCoownerId}
    />
  )
}

const ResolutionDisplay = (props) => {
  const classes = useStyles()
  const dataProvider = useDataProvider()

  const ag = props.agRecord
  const [resolution, setResolution] = useState({})
  if (ag.code === 1) return <AGNotAvailable />
  if (ag.open_resolution_id === null) return null

  //NOTE: we don't display tantiemes for non exprimés since for those there is no vote so we don't have resolution_id (so no repartition)
  useEffect(async () => {
    dataProvider
      .getOne(`ext_resolutions`, {
        id: ag.open_resolution_id,
      })
      .then(({ data }) => {
        if (!data.ok) {
          setResolution(data)
        } else {
          setResolution({})
        }
      })
      .catch((error) => {
        // setError(error);
      })
    const result = await Api.resolutions.getOneResolutionFromExtranet(
      ag.open_resolution_id
    )
    const { data } = result

    setResolution(data)
  }, [ag])
  return (
    <div>
      <Box
        component={Paper}
        style={{
          padding: '10px',
          color: '#2b2b2b',
          marginBottom: '5px',
          boxShadow: 'none',
          border: '1px solid #cdcdcd',
        }}
      >
        <Typography variant="subtitle1">
          <b>{ag.open_resolution_full_libelle}</b>
        </Typography>
        <Typography
          variant="subtitle2"
          align="justify"
          dangerouslySetInnerHTML={{ __html: ag.open_resolution_contenu_bo }}
        ></Typography>
      </Box>
      <Box>
        <CreateVoteToolbar
          handleSubmit={props.handleSubmit}
          vote={props.vote}
        />
      </Box>
      <br />
      {ag.open_resolution_majorite !== 'sans vote' ? (
        <div>
          <Typography
            className={classes.resolutionDisplayFlex}
            style={{
              color: '#484848',
              display: 'flex',
              padding: '10px',
              marginBottom: '5px',
              boxShadow: 'none',
              border: '1px solid #cdcdcd',
            }}
            component={Paper}
          >
            <div className={classes.resolutionDisplayDiv}>
              <span style={{ with: '5em' }}>Pour</span>
              <span
                className={classes.percent}
                style={{ background: '#239a25f2', padding: '8px' }}
              >
                {resolution.tantiemes_pour_percent} {' %'}
              </span>
            </div>{' '}
            <Box className={classes.badges}>
              {ag.open_resolution_votes.filter((v) => v.vote === 'Pour')
                .length ? (
                ag.open_resolution_votes
                  .filter((v) => v.vote === 'Pour')
                  .map((v) => {
                    return (
                      <Pill
                        key={v.id}
                        id="light"
                        value={v.libelle + ' (' + v.tantiemes + ') '}
                        status="dark"
                        style={{
                          marginLeft: '10px',
                          color: 'black',
                        }}
                      />
                    )
                  })
              ) : (
                <p style={{ fontSize: '13px', marginLeft: '10px' }}>
                  Aucune personne
                </p>
              )}
            </Box>
          </Typography>
          <Typography
            className={classes.resolutionDisplayFlex}
            style={{
              color: '#484848',
              display: 'flex',
              padding: '10px',
              marginBottom: 5,
              boxShadow: 'none',
              border: '1px solid #cdcdcd',
            }}
            component={Paper}
          >
            <div className={classes.resolutionDisplayDiv}>
              <span>Contre</span>
              <span
                className={classes.percent}
                style={{ background: '#95000ef2', padding: '8px' }}
              >
                {resolution.tantiemes_contre_percent} {' %'}
              </span>
            </div>{' '}
            <Box className={classes.badges}>
              {ag.open_resolution_votes.filter((v) => v.vote === 'Contre')
                .length ? (
                ag.open_resolution_votes
                  .filter((v) => v.vote === 'Contre')
                  .map((v) => {
                    return (
                      <Pill
                        id="light"
                        value={v.libelle + ' (' + v.tantiemes + ') '}
                        status="dark"
                        style={{ marginLeft: '10px', color: 'black' }}
                      />
                    )
                  })
              ) : (
                <p style={{ fontSize: '13px', marginLeft: '10px' }}>
                  Aucune personne
                </p>
              )}
            </Box>
          </Typography>
          <Typography
            className={classes.resolutionDisplayFlex}
            style={{
              color: '#484848',
              display: 'flex',
              padding: '10px',
              marginBottom: 5,
              boxShadow: 'none',
              border: '1px solid #cdcdcd',
            }}
            component={Paper}
          >
            <div className={classes.resolutionDisplayDiv}>
              <span>Abstention</span>
              <span
                className={classes.percent}
                style={{ background: '#000000f2', padding: '8px' }}
              >
                {resolution.tantiemes_abstention_percent} {' %'}
              </span>
            </div>{' '}
            <Box className={classes.badges}>
              {ag.open_resolution_votes.filter((v) => v.vote === 'Abstention')
                .length ? (
                ag.open_resolution_votes
                  .filter((v) => v.vote === 'Abstention')
                  .map((v) => {
                    return (
                      <Pill
                        id="light"
                        value={v.libelle + ' (' + v.tantiemes + ') '}
                        status="dark"
                        style={{ marginLeft: '10px', color: 'black' }}
                      />
                    )
                  })
              ) : (
                <p style={{ fontSize: '13px', marginLeft: '10px' }}>
                  Aucune personne
                </p>
              )}
            </Box>
          </Typography>
          <Typography
            className={classes.resolutionDisplayFlex}
            style={{
              color: '#2b2b2b',
              display: 'flex',
              padding: '10px',
              marginBottom: 5,
              boxShadow: 'none',
              border: '1px solid #cdcdcd',
            }}
            component={Paper}
          >
            <div className={classes.resolutionDisplayDiv}>
              <span>Non exprimés</span>
              <span
                className={classes.percent}
                style={{
                  background: '#ececec',
                  border: '1px dotted #cdcdcd',
                  padding: '8px',
                  color: 'black',
                }}
              >
                {resolution.tantiemes_sansvote_percent} {' %'}
              </span>
            </div>{' '}
            <Box className={classes.badges}>
              {ag.open_resolution_votes.filter((v) => v.vote === null)
                .length ? (
                ag.open_resolution_votes
                  .filter((v) => v.vote === null)
                  .map((v) => {
                    return (
                      <Pill
                        id="light"
                        value={v.libelle}
                        status="dark"
                        style={{ marginLeft: '10px', color: 'black' }}
                      />
                    )
                  })
              ) : (
                <p style={{ fontSize: '13px', marginLeft: '10px' }}>
                  Aucune personne
                </p>
              )}
            </Box>
          </Typography>
        </div>
      ) : (
        <div />
      )}
    </div>
  )
}

const ResDetails = (props) => {
  const record = useRecordContext()
  if (record.subs.length > 0) return null
  return (
    <div>
      <div>
        Pour : {record.votes_pour !== null ? record.votes_pour.join(', ') : ''}
      </div>
      <div>
        Contre :{' '}
        {record.votes_contre !== null ? record.votes_contre.join(', ') : ''}
      </div>
      <div>
        Abstention :{' '}
        {record.votes_abstention !== null
          ? record.votes_abstention.join(', ')
          : ''}
      </div>
    </div>
  )
}

const Results = (props) => {
  const record = useRecordContext(props)
  if (!record || record.open_resolution_id === null) return null

  return (
    <SimpleShowLayout variant="outlined" {...props}>
      <Title4 />
      <ArrayField source="ext_resolutions" label=" ">
        <Datagrid expand={<ResDetails />} bulkActionButtons={false}>
          <TextField label="Intitulé" source="full_libelle" />
          <TextField label="Statut" source="status" />
        </Datagrid>
      </ArrayField>
      <HelpSection />
    </SimpleShowLayout>
  )
}

const VisioButton = (props) => {
  const { ag } = props

  if (ag === null) return null

  const openVisio = () => {
    if (
      ag.visio_link === undefined ||
      ag.visio_link === 'undefined' ||
      ag.visio_link === null
    ) {
      return
    }
    window.open(ag.visio_link, '_blank')
  }

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justify="center"
      style={{ marginBottom: '20px' }}
    >
      <Grid item xs={12}>
        <Button color="primary" variant="outlined" onClick={openVisio}>
          Accédez à la visioconférence !
        </Button>
      </Grid>
    </Grid>
  )
}

//I have no idea why, I tried everything but neither Show or Edit component
//with custom resource rendered anything. I literally investigated everything.
//So in the end, I fetch data myself.
//NOTE: I had the same problem in ags JS file. I found a nice workaround: I declare each resource in App.js
//with its matching edit component, in each edit component I put the Edit and Show stuff,
//and I make a common Tabs component which simply changes the URL when switching tab.
const TabX = (props) => {
  const [ag, setAg] = useState(null)
  const inputVoteRef = useRef(null)
  const notify = useNotify()
  const dataProvider = useDataProvider()
  const [voted, setVoted] = useState('')

  const checkVoted = (token, record) => {
    if (token) {
      dataProvider
        .getOne(`ext_votes/check_vote/${token}`, {
          id: record.open_resolution_id,
        })
        .then(({ data }) => {
          if (!data.ok) {
            setVoted(data.message)
          } else {
            setVoted('')
          }
        })
        .catch((error) => {
          // setError(error);
        })
    }
  }
  const refresh = () => {
    if (!props.resource) return

    dataProvider
      .getOne(props.resource, { id: window.context['context-token'] })
      .then((response) => {
        setAg(response.data)
        checkVoted(window?.formData2?.token, response.data)
      })
      .catch((error) => {
        alert(error.message)
        notify(error.message, 'warning')
      })
  }

  useEffect(() => {
    refresh()
    var interval = setInterval(function () {
      refresh()
    }, 25000)
    return function cleanup() {
      clearInterval(interval)
    }
  }, [])

  if (ag === null) return null

  if (props.resource === 'ext_ags2a') {
    return <RegisterWrapper toVote={props.toVote} refresh={refresh} ag={ag} />
  }
  if (props.resource === 'ext_ags2b') {
    return (
      <VoteWrapper
        refresh={refresh}
        ag={ag}
        voted={voted}
        setVoted={setVoted}
        inputVoteRef={inputVoteRef}
        {...props}
      />
    )
  }
  if (props.resource === 'ext_ags2c') {
    return (
      <div>
        <VisioButton ag={ag} />
        <Results record={ag} />
      </div>
    )
  }
  if (props.resource === 'ext_ags2d') {
    return <CustomFileDetailTable rows={ag.data} />
  }
  return null
}

//NOTE: I suspect resource can have a _ but NOT a -
//+ DONT FORGET TO DECLARE ALL RESOURCES IN APP.JS!!!
//NOTE: HERE we don't declare the Show component in Admin resource Show prop, because:
//For all the references to work we need ag id to be ag copromatic_id
//so we cannot use ag code as id, like for other extranets
//NOTE2: we put Vote form and then open resolution SimpleShowLayout in sequence,
//cuz if we nest SimpleShowLayout/SimpleForm, MuiCard padding accumulates and both
//areas are not aligned vertically
export const Ag = (props) => {
  const { hash } = useLocation()
  const tab = hash.substring(1) || props.tab
  return (
    props.tabs && (
      <div>
        {tab === props.tabs[0].id && <TabX {...props} resource="ext_ags2a" />}
        {tab === props.tabs[1].id && <TabX {...props} resource="ext_ags2b" />}
        {tab === props.tabs[2].id && <TabX {...props} resource="ext_ags2c" />}
        {tab === props.tabs[3].id && <TabX {...props} resource="ext_ags2d" />}
      </div>
    )
  )
}

//We replicate MUItheme here just to override palette.background.default for react drop-zone background color in ImageInput
const widthVar = '190'
const customTheme = createTheme({
  palette: {
    primary: {
      main: '#000',
      contrastText: 'white',
    },
    secondary: {
      main: '#ff7675',
      contrastText: '#ffffff',
    },
    background: {
      default: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Arial, sans-serif',
  },
  overrides: {
    MuiRadio: {
      colorPrimary: {
        color: 'black',
        '&$checked': {
          color: 'black',
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        '&$focused $notchedOutline': {
          borderColor: 'black',
        },
      },
    },
    MuiFormLabel: {
      root: {
        '&$focused': {
          color: 'black',
        },
      },
    },
  },
})

export const ExtranetAgs = (props) => {
  const tabs = [
    { id: 'enregistrement', name: 'Enregistrement' },
    { id: 'vote', name: 'Vote' },
    { id: 'resultats', name: 'Visio et Résultats' },
    { id: 'annexes', name: 'Annexes' },
  ]

  const [tab, setTab] = useState(tabs[0].id)
  const classes = useStyles()
  const location = useLocation()
  window.context['context-token'] = location.pathname.replace('/ext_ags2/', '')

  useEffect(() => {
    if (location.hash.length > 1) {
      // eslint-disable-next-line no-undef
      handleChange(_, location.hash.substring(1))
    }
  }, [location.hash])

  const toVote = () => {
    window.location.hash = `#${tabs[1].id}`
  }

  const handleChange = (event, value) => {
    window.location.hash = `#${value}`
    setTab(value)
  }

  //NOTE: I had weird bugs with Show components, they didnt show anything.
  //NOTE: Registration form was reset each time refresh from useRefresh was used, so finally I stopped using a Create around this form
  //NOTE: we let SignaturePad drive the width (all React-admin fields have fullWidth props so they adapt)
  //and we use maxWidth on grid container to control maxWidth
  return (
    <MuiThemeProvider theme={customTheme}>
      <AppBar
        elevation={0}
        position="sticky"
        style={{ marginTop: '.5em', fontSize: '1em' }}
        className={classes.tabBar}
      >
        <Tabs
          style={{ backgroundColor: 'black' }}
          variant="standard"
          centered={true}
          sx={{ width: '90%', fontSize: '1em' }}
          value={tab}
          onChange={handleChange}
          TabIndicatorProps={{
            style: { backgroundColor: 'white' },
          }}
        >
          {tabs.map((choice) => (
            <Tab
              style={{
                minWidth: widthVar,
                maxWidth: widthVar,
                width: widthVar,
                padding: '0',
              }}
              key={choice.id}
              label={choice.name}
              value={choice.id}
            />
          ))}
        </Tabs>
      </AppBar>
      <Divider />
      <div className={classes.wrapper}>
        <ExtranetContainer xs={11} md={6} alignItems="stretch">
          <Card elevation={5}>
            <CardContent>
              <Ag {...props} tab={tab} tabs={tabs} toVote={toVote} />
            </CardContent>
          </Card>
        </ExtranetContainer>
      </div>
    </MuiThemeProvider>
  )
}

const EmptyToolbar = (props) => {
  return null
}

const AGStuff = (props) => {
  //resource here must be the same than the one specified in App.js
  //for the list component containing this one, no idea why
  //Maybe cuz useGetOne uses redux store and there are some consequences
  const { data, loading, error } = useGetOne('ext_ags2', props.code)

  if (error) {
    return null
  }
  if (!data) {
    return null
  }

  //data.code === 1 means the AG cannot be accessed
  if (data.code === 1) return <AGNotAvailable />

  const openVisio = () => {
    if (
      data.visio_link === undefined ||
      data.visio_link === 'undefined' ||
      data.visio_link === null
    ) {
      return
    }
    window.open(data.visio_link, '_blank')
  }

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justify="center"
    >
      <Grid item xs={12}>
        <Typography
          variant="h5"
          gutterBottom={true}
          style={{ color: '#575756' }}
        >
          Assemblée générale
        </Typography>
        <Typography>
          Bonjour et bienvenue!
          <br />
          Vous trouverez ci-dessous quelques indications pour vous connecter.
          <br />
          <br />
          <b>Etape 1 : le check-in.</b> Vous devez tout d'abord procéder à votre{' '}
          <b>enregistrement</b> (bouton 1). Pour cela, munissez-vous de votre
          pièce d'identité ou du pouvoir, et signer. Ca marche sur smartphone !{' '}
          <b>Vous devez recevoir un code par SMS en confirmation</b>.
          <br />
          <br />
          <b>Etape 2 : la visio.</b> Ensuite, vous devez cliquer sur le second
          bouton pour activer la visioconférence (le nôtre, ou Zoom selon l'AG).
          Veillez à bien activer la caméra et le son :)
          <br />
          <br />
          <b>En cas de besoin : connexion par téléphone</b>
          <br />
          {data.visio_call}
          <br />
          <br />
          <b>Informations et aide</b>
          <br />
          {data.visio_helper}
        </Typography>
        <br />
      </Grid>
      <Button
        fullWidth
        onClick={props.go}
        variant="contained"
        color="primary"
        disableElevation
      >
        Etape 1: Enregistrement
      </Button>
      <br />
      <Button fullWidth color="primary" variant="outlined" onClick={openVisio}>
        Etape 2: Accédez à la visioconférence
      </Button>
    </Grid>
  )
}

const AGStuffW = (props) => {
  if (props.code === '' || props.code === undefined) {
    return null
  }
  return <AGStuff {...props} />
}

export const ExtranetAgsHome = (props) => {
  const [code, setCode] = useState('')
  const [finalcode, setFinalCode] = useState('')
  const navigate = useNavigate()
  const dataProvider = useDataProvider()
  const classes = useStyles()

  const search = () => {
    setFinalCode(code)
    navigate(`/ext_ags2/${code}`)
  }
  const location = useLocation()
  if (location.search !== '' && finalcode === '') {
    var url_code = location.search.replace('?code=', '')
    setFinalCode(url_code)
  }

  const go = () => {
    navigate(`/ext_ags2/${finalcode}`)
  }

  if (finalcode !== '') {
    return (
      <div>
        <ExtranetContainer xs={11} md={8} alignItems="stretch">
          <Card className={classes.introCard} elevation={5}>
            <CardMedia
              className={classes.introCardMedia}
              image={config.PUBLIC_URL + '/img/ag_pic_post_code.jpg'}
            />
            <div className={classes.introCardContent}>
              <CardContent>
                <AGStuffW code={finalcode} go={go} />
              </CardContent>
            </div>
          </Card>
        </ExtranetContainer>
      </div>
    )
  }

  //We use an outer ExtranetContainer to have Card centered.
  return (
    <div>
      <ExtranetContainer xs={11} md={8} alignItems="stretch">
        <Card className={classes.introCard} elevation={5}>
          <CardMedia
            className={classes.introCardMedia}
            image={config.PUBLIC_URL + '/img/ag_pic.jpg'}
          />
          <div className={classes.introCardContent}>
            <CardContent>
              <Typography
                variant="h4"
                gutterBottom={true}
                style={{ color: '#575756' }}
              >
                Votre assemblée générale digitale
              </Typography>
              <Typography variant="subtitle1" style={{ color: '#575756' }}>
                Vous pouvez désormais participer à votre Assemblée Générale
                depuis chez vous! Veuillez renseigner le code de l'Assemblée
                Générale à laquelle vous voulez vous connecter. Vous avez reçu
                ce code avec votre convocation.
              </Typography>
            </CardContent>
            <SimpleForm
              toolbar={<EmptyToolbar />}
              variant="outlined"
              defaultValues={{ ag_id: -1 }}
              redirect={false}
              submit={go}
              resource="ext_ags2"
              basePath="/"
            >
              <TextInput
                fullWidth
                label="Code d'AG"
                source="code"
                validate={required()}
              />
              <FormDataConsumer>
                {({ formData, ...rest }) => {
                  setCode(formData.code)
                  return null
                }}
              </FormDataConsumer>
              <Button
                disabled={!code}
                fullWidth
                size="large"
                variant="contained"
                color="primary"
                disableElevation
                onClick={search}
              >
                Participer
              </Button>
            </SimpleForm>
          </div>
        </Card>
      </ExtranetContainer>
    </div>
  )
}
